export default __webpack_public_path__ + "static/media/logoEmpresaLoading.68b07470.gif";